export default __webpack_public_path__ + "development-2.png";